const colors = {
    interaction45: "hsl(221 75% 45%)",
    interaction50: "hsl(221 91% 50%)",
    interaction55: "hsl(221 91% 55%)",
    interaction66: "hsl(221 91% 66%)",
    interaction97: "hsl(221 89% 97%)",
    lightNeutral12: "hsl(0 0% 12%)",
    lightNeutral24: "hsl(0 0% 24%)",
    lightNeutral45: "hsl(0 0% 45%)",
    lightNeutral81: "hsl(0 0% 81%)",
    lightNeutral88: "hsl(0 0% 88%)",
    lightNeutral93: "hsl(0 0% 93%)",
    lightNeutral95: "hsl(0 0% 95%)",
    warning20: "hsl(42 100% 20%)",
    warning49: "hsl(42 84% 49%)",
    warning94: "hsl(42 84% 94%)"};

export { colors as default };
//# sourceMappingURL=colors.js.map
